<template>
  <div class="offer-report-wrapper">
    <div class="contentSection custom-padding mb-3 mt-0">
      <div id="chart"></div>
    </div>
    <div class="col-md-12">
      <div class="row">
          <BaseIconSelect
          customClass="col-md-3"
           :icon="{css: 'fas fa-calendar'}"
            v-model="selectedReportDate"
            @select="(value) => (getOfferReport(value))"
            :items="[
              { name: 'Today', value: 'today'},
              { name: 'Last 7 Days', value: 'last7days'},
              { name: 'Month To Date', value: 'monthToDate'},
          ]"/>
          <BaseIconSelect
            customClass="col-md-3"
            :icon="{css: 'fas fa-eye'}"
            v-model="selectedChartOption"
            @select="(value) => (renderChart(selectedChartOption.name, selectedChartOption.value))"
            :items="[
              { name: 'Revenue', value: 'revenue' },
              { name: 'Conversion Rate', value: 'conversion_rate' },
              { name: 'Views', value: 'views' }
          ]"/>
          <BaseSearchInput customClass="col-md-3 offset-md-3" @searchterm="searchOffersReport($event)"/>
      </div>
    </div>
      <BaseTable
        :columns="columns"
        :tableData="offerReportForTable"
        :pagination="{}"
        :paginationParams="{}"
        :downloadCsv="true"
        :indexCallback="function(){}"
        :totals="true">
        <span slot="rpv" slot-scope="{row}">
          {{ (row.revenue / row.views) | currency }}
        </span>
      </BaseTable>
  </div>
</template>
<script>
import Reports from '@/resources/TrackingReports.js'
import ApexCharts from 'apexcharts'
import moment from 'moment'

var offerReport = []
var chartInstance = null

export default {
  data () {
    return {
      offerReportIndexed: [],
      offerReportForTable: [],
      selectedReportDate: { name: 'Today', value: 'today' },
      selectedChartOption: { name: 'Views', value: 'views' },
      offers: [],
      columns: [
        { name: 'Offer Name', key: 'name', class: 'col-md-3' },
        { name: 'Sets', key: 'set_count', class: 'col-md-1' },
        { name: 'Views', key: 'views', class: 'col-md-1', filter: 'number', fallback: '0' },
        { name: 'Clicks', key: 'yes_click', class: 'col-md-1', filter: 'number', fallback: '0' },
        { name: 'Conv %', key: 'conversion_rate', class: 'col-md-2', filter: 'percentage', fallback: '0%' },
        { name: 'CPC', key: 'cost_per_click', class: 'col-md-1', fallback: '0' },
        { name: 'RPV', key: 'rpv', class: 'col-md-1' },
        { name: 'Revenue', key: 'revenue', class: 'col-md-2', filter: 'currency', fallback: '0' }
      ],
      date: new Date(),
      totals: {},
      index: {
        limit: 10,
        page: 1,
        total: null
      },
      pagination: {}
    }
  },
  methods: {
    searchOffersReport (event) {
      this.offerReportIndexed = []
      this.offerReportForTable = []
      offerReport.filter((offer) => {
        if (offer.name.toLowerCase().includes(event.search.toLowerCase())) {
          this.offerReportForTable.push(offer)
          this.offerReportIndexed.push(offer)
        }
      })
      this.totals = this.calculateTotals(this.offerReportForTable)
      this.offerReportForTable.push(this.totals) // TODO: maybe provide these totals through the api
      this.renderChart(this.selectedChartOption.name, this.selectedChartOption.value)
    },
    configureChart (data, categories, name) {
      var currency = false
      var percentage = false
      if (name === 'Revenue') currency = true
      if (name === 'Conversion Rate') percentage = true
      return {
        chart: {
          height: 350,
          type: 'bar'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            endingShape: 'flat',
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        title: {
          text: '',
          align: 'center'
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        series: data,
        xaxis: {
          categories: categories
        },
        fill: {
          opacity: 1

        },
        yaxis: {
          title: {
            text: name
          },
          labels: {
            formatter: function (y) {
              if (percentage) return y.toFixed(2) + '%'
              if (currency) return '$' + y.toFixed(2)
              return y
            }
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              if (currency) return '$' + val.toFixed(2)
              if (percentage) return val.toFixed(2) + '%'
              return val
            }
          }
        }
      }
    },
    loadChart (options, id) {
      if (chartInstance) {
        chartInstance.destroy()
      } else {

      }
      chartInstance = new ApexCharts(this.$el.querySelector(id), options)
      chartInstance.render()
    },
    setDateRange (date) {
      let dateRange = {}
      dateRange['start_date'] = moment.utc().startOf('day').format('YYYY-MM-DD HH:mm:ss')
      dateRange['end_date'] = moment.utc().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      switch (date.value) {
        case 'today':
          dateRange['start_date'] = moment.utc().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          dateRange['end_date'] = moment.utc().endOf('day').format('YYYY-MM-DD HH:mm:ss')
          break
        case 'monthToDate':
          dateRange['start_date'] = moment.utc().startOf('month').format('YYYY-MM-DD HH:mm:ss')
          dateRange['end_date'] = moment.utc().endOf('month').format('YYYY-MM-DD HH:mm:ss')
          break
        case 'last7days':
          dateRange['start_date'] = moment.utc().subtract('7', 'd').format('YYYY-MM-DD HH:mm:ss')
          dateRange['end_date'] = moment.utc().endOf('date').format('YYYY-MM-DD HH:mm:ss')
          break
      }
      return dateRange
    },
    calculateTotals (data) {
      let totals = {
        'name': 'Totals',
        'conversion_rate': 0,
        'views': 0,
        'yes_click': 0,
        'rpv': 0,
        'revenue': 0
      }
      let percentages = []
      for (let i = 0; i < data.length; i++) {
        const item = data[i]
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            const field = item[key]
            switch (key) {
              case 'conversion_rate':
                percentages.push(parseFloat(field))
                break
              case 'name':
                // do nothing
                break
              case 'views':
                totals[key] += parseFloat(field)
                break
              case 'yes_click':
                totals[key] += parseFloat(field)
                break
              case 'revenue':
                totals[key] += parseFloat(field)
                break
              case 'rpv':
                totals[key] += parseFloat(field)
                break
              default:
                totals[key] = '-'
                break
            }
          }
        }
      }
      totals['conversion_rate'] = this.findAveragePercentage(percentages)
      return totals
    },
    findAveragePercentage (percentages) {
      let total = 0
      for (let i = 0; i < percentages.length; i++) {
        percentages[i] = percentages[i] / 100
        total += percentages[i]
      }
      total = total / (percentages.length)
      return total * 100
    },
    getOfferReport (dateRange) {
      Reports.offers(this.setDateRange(dateRange))
        .then((response) => {
          offerReport = response
          this.offerReportIndexed = response
          this.offerReportForTable = JSON.parse(JSON.stringify(response))
          this.totals = this.calculateTotals(response)
          this.offerReportForTable.push(this.totals) // TODO: maybe provide these totals through the api
          this.renderChart(this.selectedChartOption.name, this.selectedChartOption.value)
        })
    },
    buildChart (data, name, type) {
      let barData = []
      let categories = []
      for (var i = 0; i < data.length; i++) {
        let offer = data[i]
        if (type === 'revenue') {
          barData.push(parseFloat(offer.revenue))
        } else if (type === 'views') {
          barData.push(parseInt(offer.views))
        } else {
          barData.push(parseFloat(offer.conversion_rate))
        }
        categories.push(offer.name)
      }
      let chart = {
        data: [
          { name: name, data: barData }
        ],
        categories: categories
      }
      return chart
    },
    renderChart (name, type) {
      let chart = this.buildChart(this.offerReportIndexed, name, type)
      let options = this.configureChart(chart.data, chart.categories, name)
      this.loadChart(options, '#chart')
    }
  }
}
</script>
<style lang="scss" scoped>
.offer-report-wrapper {
  .custom-padding {
    border-radius: 0px 0px 6px 6px;
  }
  .input-group {
    flex-wrap: nowrap;
    padding: 0px;
    span,
    .input-group-text {
      background-color: $container-bg;
    }
    .input-group-prepend,
    .input-group-text {
      max-width: 50px;
      i:before {
        margin: 0px;
      }
    }
  }
}
</style>
